module.exports = __webpack_public_path__ + "img/balanja.d7ebba6c.svg";